<mat-card>
    <ngx-datatable 
        #tableAtivo
        class='material' 
        [summaryRow]="enableSummary"
        [summaryPosition]="summaryPosition" 
        [summaryHeight]="50"
        [loadingIndicator]="loadingListaAtivo"
        [columns]="columns" 
        [columnMode]="'force'" 
        [headerHeight]="50"                       
        [footerHeight]="50" 
        [rowHeight]="'auto'" 
        [rows]='rows'
        [limit]="params.per_page"
        (sort)="onSort($event)">

        <ngx-datatable-column 
            name="Setor" 
            prop="setor" 
            [sortable]="true" 
            [summaryFunc]="totalCustodia" 
        >
            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <span>
                    <b>{{row.setor}}</b>
                </span>                                    
            </ng-template>
        </ngx-datatable-column>
     

        <ngx-datatable-column name="Financeiro (R$)" prop="vlr_financeiro" [sortable]="true" [summaryFunc]="somaFinanceiro">
            <ng-template 
                let-rowIndex="rowIndex" 
                let-vlr_financeiro="value" 
                ngx-datatable-cell-template>
                {{vlr_financeiro | number : '1.2-2'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Financeiro Hoje (R$)" prop="vlr_financeiro_hoje" [sortable]="true" [summaryFunc]="somaFinanceiroHoje">
            <ng-template
                let-rowIndex="rowIndex" 
                let-row="row" 
                ngx-datatable-cell-template
            >
                {{row.vlr_financeiro_hoje  | number : '1.2-2'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="% Participação" prop="percentual" [sortable]="false"  >
            <ng-template 
                let-rowIndex="rowIndex" 
                let-row="row" 
                ngx-datatable-cell-template>
                {{  percentualFinanceiro(row.vlr_financeiro) | number : '1.2-2'}} %
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Qtd. Clientes" prop="qtd_clientes" [sortable]="false"  >
            <ng-template 
                let-rowIndex="rowIndex" 
                let-row="row" 
                ngx-datatable-cell-template>
                {{  row.qtd_clientes | number : '1.0-0'}}
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="%" prop="percentual" [sortable]="true"  >
            <ng-template
                let-rowIndex="rowIndex" 
                let-row="row" 
                ngx-datatable-cell-template>
                <span [ngClass]="{
                    'negativo': percentualFinanceiroDiferenca(row) < 0, 
                    'positivo': percentualFinanceiroDiferenca(row) > 0}">
                    
                    {{ percentualFinanceiroDiferenca(row) | number : '1.2-2'}} %

                    <i class="material-icons negativo"  *ngIf="percentualFinanceiroDiferenca(row) < 0" style="float: left">
                        trending_down
                    </i>
                    <i class="material-icons positivo" c *ngIf="percentualFinanceiroDiferenca(row) > 0" style="float: left">
                        trending_up
                    </i>
                    <i class="material-icons"  *ngIf="percentualFinanceiroDiferenca(row) == 0" style="float: left">
                        trending_flat 
                    </i>

                </span>
               
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>

    <div style="padding: 5px 10px">
        <mat-paginator 
            #paginator 
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)">
        </mat-paginator>
    </div>
</mat-card>